// extracted by mini-css-extract-plugin
export default {"parent":"label_parent__1gSYA","parentRequired":"label_parentRequired__LxBXk"};